/**
 * DOM helpers.
 *
 * @module lib/dom
 */

import { renderToString } from './html.js';

/**
 * First element matching a selector.
 *
 * @param {string} selector
 * @param {ParentNode} [scope=document]
 * @returns {HTMLElement | null}
 */
export function $(selector, scope = document) {
    return scope.querySelector(selector);
}

/**
 * Every element matching a selector, as an array.
 *
 * @param {string} selector
 * @param {ParentNode} [scope=document]
 * @returns {HTMLElement[]}
 */
export function $$(selector, scope = document) {
    return Array.from(scope.querySelectorAll(selector));
}

/**
 * Pages are thin shells of `<div data-mount="name">` holders; this fills
 * one of them.
 *
 * @param {string} name - Value of the `data-mount` attribute.
 * @param {import('./html.js').Markup | import('./html.js').Markup[]} markup
 * @returns {HTMLElement | null} The holder, if the page has one.
 */
export function mount(name, markup) {
    const holder = $(`[data-mount="${name}"]`);

    if (holder) {
        holder.innerHTML = renderToString(markup);
    }

    return holder;
}

/**
 * Two-digit index of a list item, counted from one: 0 → "01".
 *
 * @param {number} index
 * @returns {string}
 */
export function pad(index) {
    return String(index + 1).padStart(2, '0');
}

/**
 * Two-digit count: 7 → "07".
 *
 * @param {number} count
 * @returns {string}
 */
export function padCount(count) {
    return String(count).padStart(2, '0');
}
